import { apiRequest } from './api';

/**
 * All listed option expiration dates for a symbol (YYYY-MM-DD, sorted).
 * Resolved server-side through whichever broker accounts exist
 * (schwab → tradier → robinhood → mcp), so it works for any trading broker.
 */
export async function fetchOptionExpirations(symbol) {
  if (!symbol) return [];
  try {
    const resp = await apiRequest(`/api/chains/expirations?symbol=${encodeURIComponent(String(symbol).trim().toUpperCase())}`);
    const dates = resp.data?.dates || [];
    return Array.isArray(dates) ? dates.filter(Boolean).sort() : [];
  } catch {
    return [];
  }
}

/**
 * Nearest weekly expiration for a symbol. Weeklies expire on Fridays —
 * returns the earliest listed Friday on/after today (also skips daily
 * series like SPX's). Falls back to the earliest listed date, else null.
 */
export async function fetchNearestWeeklyExpiration(symbol) {
  const dates = await fetchOptionExpirations(symbol);
  const today = new Date().toISOString().slice(0, 10);
  const future = dates.filter(d => d >= today);
  const friday = future.find(d => new Date(`${d}T12:00:00`).getDay() === 5);
  return friday || future[0] || null;
}
